export default __webpack_public_path__ + "static/media/diet@3x.83bd2f9b.jpg";